module.exports = __webpack_public_path__ + "img/leflet-icon-with-shadow.caa9a7c8.svg";